import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {ApiCollection, ApiResponse, AuditLogRow} from '@core/types';
import {ENDPOINTS, GET_URL, log} from '@core/utils';
import {HttpService} from '@core/services';
import {CompanyStateService} from '@core/states';
import {AuthStateService} from '@auth/states';

@Injectable({
  providedIn: 'root'
})
export class AuditService {
  constructor(
    private apiService: HttpService,
    private companyState: CompanyStateService,
    private authState: AuthStateService
  ) {}

  async getAuditLogs(
    page = 1,
    itemsPerPage = 200,
    options?: {skipLoader?: boolean}
  ): Promise<ApiResponse<AuditLogRow[]>> {
    try {
      const url = GET_URL(ENDPOINTS.AUDIT_LOGS, {
        page,
        itemsPerPage,
        'order[createdAt]': 'desc'
      });
      const headers = this.buildHeaders(options?.skipLoader);
      const response: ApiCollection<any> = await this.apiService.get(url, headers ? {headers} : undefined);
      const rows = this.apiService.normalizeCollection<any>(response).member.map(item => this.mapAuditLog(item));
      return {success: true, result: rows};
    } catch (error: any) {
      log.error('Error loading audit logs:', error);
    }
    return {success: false, message: 'No se pudieron cargar los logs de auditoría.'};
  }

  private mapAuditLog(item: any): AuditLogRow {
    return {
      id: item.id,
      action: item.action,
      entityName: item.entityName || item.entity_name,
      entityId: item.entityId || item.entity_id,
      payload: item.payload || {},
      occurredAtIso: item.occurredAtIso || item.occurred_at_iso,
      createdAt: item.createdAt || item.created_at,
      actorId: item.actorId || item.actor_id || null,
      actorName: item.actorName || item.actor_name || null,
      actorEmail: item.actorEmail || item.actor_email || null,
    };
  }

  private buildHeaders(skipLoader = false): HttpHeaders | null {
    if (this.authState.isAdmin()) {
      if (!skipLoader) return null;
      return new HttpHeaders().set('X-Skip-Loader', '1');
    }

    const companyId = this.companyState.membership()?.company?.id;
    if (!companyId) {
      if (!skipLoader) return null;
      return new HttpHeaders().set('X-Skip-Loader', '1');
    }

    let headers = new HttpHeaders().set('X-Selected-Company-ID', String(companyId));
    if (skipLoader) {
      headers = headers.set('X-Skip-Loader', '1');
    }
    return headers;
  }
}
